"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommunitySearch = CommunitySearch;
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _TextField2 = _interopRequireDefault(require("@mui/material/TextField"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Close2 = _interopRequireDefault(require("@mui/icons-material/Close"));
var _InputAdornment2 = _interopRequireDefault(require("@mui/material/InputAdornment"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _trophyIllus = _interopRequireDefault(require("../assets/images/trophy-illus-2.svg"));
var _services = require("../services");
var _communityItem = require("./community-item");
var _createCommunityCard = _interopRequireDefault(require("./create-community-card"));
var _icons = require("./icons");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function CommunitySearch({
  Button,
  Dialog,
  currentUser,
  userGeogroups,
  createCommunityCardActions,
  handleClick,
  handleCommunityJoined,
  handleTryToJoinAsGuest
}) {
  const [initialized, setInitialized] = (0, _react.useState)(false);
  const [geogroups, setGeogroups] = (0, _react.useState)([]);
  const [joinedGeogroups, setJoinedGeogroups] = (0, _react.useState)();
  const [search, setSearch] = (0, _react.useState)('');
  const fetch = (0, _react.useMemo)(() => (0, _debounce.default)(async (search, callback) => {
    const {
      geogroups
    } = await _services.GeogroupService.getGeogroups({
      pageSize: 100,
      page: 1,
      search,
      types: ['city', 'association', 'school', 'company', 'private', 'other']
    });
    callback(geogroups);
  }, 700), []);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  (0, _react.useEffect)(() => {
    setInitialized(true);
  }, []);
  (0, _react.useEffect)(() => {
    if (userGeogroups) {
      setJoinedGeogroups([...userGeogroups].filter(({
        status
      }) => status === 'manuallyJoin'));
    }
    return () => setJoinedGeogroups(undefined);
  }, [userGeogroups]);
  (0, _react.useEffect)(() => {
    if (!initialized) return;
    let active = true;
    if (search && search.length > 1) {
      setGeogroups(undefined);
      fetch(search, geogroups => {
        if (active) setGeogroups(geogroups);
      });
    }
    return () => {
      active = false;
      setGeogroups([]);
    };
  }, [initialized, search, fetch]);
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 5
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    flexShrink: 0
  }, /*#__PURE__*/_react.default.createElement(_TextField2.default, {
    fullWidth: true,
    margin: "dense",
    onChange: ({
      currentTarget: {
        value
      }
    }) => setSearch(value),
    placeholder: t('commons.communities.actions.search') || '',
    size: "small",
    slotProps: {
      input: {
        startAdornment: /*#__PURE__*/_react.default.createElement(_InputAdornment2.default, {
          position: "start"
        }, /*#__PURE__*/_react.default.createElement(_icons.SearchIcon, {
          fontSize: "small"
        })),
        endAdornment: search && /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
          placement: "bottom",
          title: t('commons.actions.clear')
        }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
          onClick: () => setSearch(''),
          size: "small"
        }, /*#__PURE__*/_react.default.createElement(_Close2.default, null)))
      }
    },
    type: "text",
    value: search,
    variant: "outlined"
  })), geogroups ? geogroups.length > 0 ? /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 3
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "stretch",
    display: "flex",
    flexWrap: "wrap",
    gap: 2,
    justifyContent: "center"
  }, geogroups.map(geogroup => /*#__PURE__*/_react.default.createElement(_communityItem.CommunityItem, {
    Button: Button,
    currentUser: currentUser,
    Dialog: Dialog,
    geogroup: geogroup,
    handleClick: handleClick,
    handleCommunityJoined: handleCommunityJoined,
    handleTryToJoinAsGuest: handleTryToJoinAsGuest,
    joined: Boolean(joinedGeogroups?.find(({
      group: {
        id
      }
    }) => id === geogroup.id)),
    key: geogroup.id
  }))), /*#__PURE__*/_react.default.createElement(_createCommunityCard.default, {
    createCommunityCardActions: createCommunityCardActions
  })) : !search || search.length === 1 ? /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: 3,
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement("img", {
    height: 200,
    src: _trophyIllus.default
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    fontWeight: 700
  }, t('commons.communities.search.title')), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    variant: "body2"
  }, t('commons.communities.search.description')))) : /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 3,
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 1,
    justifyContent: "center",
    minHeight: 200
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    fontWeight: 700,
    variant: "h6"
  }, t('commons.communities.search.empty_state_title')), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center"
  }, t('commons.communities.search.empty_state_description'))), /*#__PURE__*/_react.default.createElement(_createCommunityCard.default, {
    createCommunityCardActions: createCommunityCardActions
  })) : /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "stretch",
    display: "flex",
    flexWrap: "wrap",
    gap: 2,
    justifyContent: "center"
  }, new Array(10).fill(null).map((_, index) => /*#__PURE__*/_react.default.createElement(_communityItem.CommunityItem, {
    key: index
  }))));
}